import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs, 
  getDoc,
  query, 
  where,
  orderBy,
  Timestamp 
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION_NAME = 'clientes';

// Crear un nuevo cliente
export const crearCliente = async (clienteData) => {
  try {
    const dataWithTimestamp = {
      ...clienteData,
      pagoCompletado: false,
      fechaRegistro: Timestamp.now(),
      activo: true
    };
    const docRef = await addDoc(collection(db, COLLECTION_NAME), dataWithTimestamp);
    return { id: docRef.id, ...dataWithTimestamp };
  } catch (error) {
    console.error("Error al crear cliente:", error);
    throw error;
  }
};

// Obtener todos los clientes
export const obtenerClientes = async () => {
  try {
    const q = query(
      collection(db, COLLECTION_NAME), 
      where("activo", "==", true),
      orderBy("fechaRegistro", "desc")
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      fechaRegistro: doc.data().fechaRegistro?.toDate()
    }));
  } catch (error) {
    console.error("Error al obtener clientes:", error);
    throw error;
  }
};

// Obtener un cliente por ID
export const obtenerClientePorId = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data(),
        fechaRegistro: docSnap.data().fechaRegistro?.toDate()
      };
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error al obtener cliente por ID:", error);
    throw error;
  }
};

// Actualizar un cliente
export const actualizarCliente = async (id, datosActualizados) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, {
      ...datosActualizados,
      fechaActualizacion: Timestamp.now()
    });
    return { id, ...datosActualizados };
  } catch (error) {
    console.error("Error al actualizar cliente:", error);
    throw error;
  }
};

// Eliminar cliente (borrado lógico)
export const eliminarCliente = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, { activo: false });
    return true;
  } catch (error) {
    console.error("Error al eliminar cliente:", error);
    throw error;
  }
};